import useCrossSell from './useCrossSell';

import type { ProductData } from '@Types/Product';

const useSortedCrossSellBy = (field: keyof ProductData, id: number): ProductData[] => {
  const { data } = useCrossSell(id);

  return data.flatMap((items) => items.products.filter((product) => product[field]));
};

export default useSortedCrossSellBy;
